require('./bootstrap');
require('./components');
require('./mixins');
require('./services');

import Vue from 'vue';
import store from '@store';
import vuetify from './plugins/vuetify';
import vuemeta from './plugins/vuemeta';

new Vue({
    vuetify,
    store,
    el: '#app',
    metaInfo: vuemeta,
});